import { reactive, computed } from 'vue';
import { clone } from 'ramda';
import { fetchSites } from '@/api/site/SiteApi';

const storageKey = 'selectedSiteId';

const siteState = reactive({
  selectedSite: {},
  sites: [],
  isInitialized: false,
});

export const loadSites = async () => {
  if (!siteState.isInitialized) {
    siteState.sites = await fetchSites();
    siteState.isInitialized = true;
  }
}

const findSelectedSite = id => (siteState.sites || []).find(site => site.id === id);

export function setDefaultSiteId() {
  if (!localStorage.getItem(storageKey)) {
    localStorage.setItem(storageKey, process.env.VUE_APP_DEFAULT_SITE_ID);
  }
}

const useSiteProvider = () => {
  siteState.selectedSite = findSelectedSite(localStorage.getItem(storageKey) || process.env.VUE_APP_DEFAULT_SITE_ID);

  const switchSite = id => {
    localStorage.setItem(storageKey, id);
    siteState.selectedSite = findSelectedSite(id);
  };

  const selectedSiteId = computed(
    () => siteState.selectedSite?.id || localStorage.getItem(storageKey) || process.env.VUE_APP_DEFAULT_SITE_ID,
  );

  const yeniSafakNewspaperSiteId = "30"
  const isSiteNewspaper = computed(() => {
    return selectedSiteId.value === yeniSafakNewspaperSiteId
  })

  const gztSiteId = "4";
  const isSiteGzt = computed(() => selectedSiteId.value === gztSiteId);

  const yeniSafakArchiveSiteId = "29";
  const isSiteArchive = computed(() => selectedSiteId.value === yeniSafakArchiveSiteId);

  return {
    switchSite,
    selectedSiteId,
    isSiteNewspaper,
    isSiteGzt,
    isSiteArchive,
    selectedSite: computed(() => clone(siteState.selectedSite)),
    sites: computed(() => clone(siteState.sites)),
  };
};

export default useSiteProvider;
